import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { User } from 'src/app/model/user';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { UserSubmit } from '../helper/user-submit';
import { Observable } from 'rxjs';
import { _get, _post, _put } from '../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class EmployeeUserControllerRequestService {
  private static BASE_URL = '/users/employee-user';
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly put: <T>(
    path: string,
    body: UserSubmit,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly post: <T>(
    path: string,
    body: UserSubmit,
    deserialize: (response: any) => T
  ) => Observable<T>;

  private readonly deserialize = (res) => res as User;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get(
      EmployeeUserControllerRequestService.BASE_URL,
      requestServices
    );
    this.post = _post(
      EmployeeUserControllerRequestService.BASE_URL,
      requestServices
    );
    this.put = _put(
      EmployeeUserControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public employeeUser(id: number): Promise<User> {
    return this.get(`/${id}`, this.deserialize).toPromise();
  }

  public createEmployeeUser(userSubmit: UserSubmit): Promise<User> {
    return this.post('', userSubmit, this.deserialize).toPromise();
  }

  public editEmployeeUser(userSubmit: UserSubmit): Promise<User> {
    return this.put('', userSubmit, this.deserialize).toPromise();
  }
}
